import { renderer } from "@b9g/crank/dom";
import { App } from "./app.tsx";

renderer.render(<App />, document.getElementById("app") as HTMLElement);
